import { add, sub, format } from "date-fns";
import { Controller } from "@hotwired/stimulus";

export default class CourseLearningPatternFormController extends Controller {
  static targets = [
    'lastPatternApplicableEndDate',
    'lastPatternParallelOperationEndDate',
    'newPatternApplicableStartDate'
  ];

  handleNewPatternApplicableStartDateChange(event) {
    if (!event.target.value) return;

    const startDate = new Date(event.target.value);

    this.lastPatternApplicableEndDateTarget.value = format(sub(startDate, { days: 1 }), 'yyyy/MM/dd');
    this.lastPatternParallelOperationEndDateTarget.value = format(add(startDate, { years: 2, days: -1 }), 'yyyy/MM/dd');
    this.lastPatternParallelOperationEndDateTarget.dispatchEvent(new Event('change'));
  }
}
